<template>
    <FormSelect
        v-if="appType"
        id="selectRegion"
        v-model="selectedRegion"
        name="selectRegion"
        string-selector="regions"
        :options="regionList"
        label-text=""
        @change="changeRegion($event)"
    >
    </FormSelect>
</template>

<script>
import { FormSelect } from '@arena/toolkit';
import domains from '@/config/domains';

const externalRegionDomains = {
    global: domains[process.env.VUE_APP_ENV].global.url,
    one: domains[process.env.VUE_APP_ENV].one.url,
    th: domains[process.env.VUE_APP_ENV].th.url,
    tw: domains[process.env.VUE_APP_ENV].tw.url,
    sea: domains[process.env.VUE_APP_ENV].sea.url,
    kr: 'https://www.nexon.com/Home/Game.aspx',
    jp: 'http://www.nexon.co.jp/',
};

export default {
    name: 'RegionSelect',
    components: {
        FormSelect,
    },
    props: {},
    data() {
        return {
            selectedRegion: '',
            regionList: [
                { value: 'global', label: 'global' },
                { value: 'th', label: 'th' },
                { value: 'tw', label: 'tw' },
                { value: 'sea', label: 'sea' },
            ],
            externalRegionLinks: externalRegionDomains,
            regionHost: externalRegionDomains,
            changeRegionUrl: null,
            passedQuery: this.$route.query,
        };
    },
    computed: {
        appType() {
            const { appType } = this.$store.state;
            return appType === 'toy' || appType === 'developers';
        },
    },
    created() {
        this.selectedRegion = environment.region;
    },
    methods: {
        changeRegion(newValue) {
            this.selectedRegion = newValue;
            this.$emit('change', this.selectedRegion);

            if (this.selectedRegion !== '' && this.selectedRegion !== environment.region) {
                const url = document.URL,
                    regionSubdomain = environment.region.replace('global', 'www'),
                    selectedRegionSubdomain = this.selectedRegion.replace('global', 'www');
                const regionUrl = url.replace(
                    location.host,
                    location.host.replace(`${regionSubdomain}.`, `${selectedRegionSubdomain}.`)
                );
                // console.log(url);
                // console.log(regionUrl);
                window.location.href = regionUrl;
            }
        },
    },
};
</script>

<style lang="less">
#selectRegion {
    .caret {
        top: 23px;
    }
}
</style>
